import { useParams } from "next/navigation";
import { useCallback, useState, useEffect } from "react";
import { motion as m } from "motion/react";

import { LayoutSideMenu } from "@/types";
import { useActiveSection } from "@/hooks/use-active-section";

import { sideMenuVariant, type SideMenuVariantProps } from "./side-menu.variants";

export type UseSideMenuProps = SideMenuVariantProps & {
  className?: string;
  data: LayoutSideMenu;
  onHandleOpenSideMenu?: (active: boolean, category: string) => void;
  isMobileMenu?: boolean;
  onHandleMenu?: (active: boolean) => void;
};

export const useSideMenu = (props: UseSideMenuProps) => {
  const {
    className = "",
    data,
    onHandleOpenSideMenu,
    isMobileMenu,
    onHandleMenu,
  } = props;
  const { name, documentations } = data;
  const params = useParams();
  const [_, __, documentation] = Array.isArray(params.slug) ? params.slug : [];

  const allAnchors = documentations.flatMap((item) =>
    item.menu.map(
      (menuItem) => menuItem.anchor.split("#")[1] ?? `page-header-${documentation}`,
    ),
  );
  const activeSection = useActiveSection(allAnchors);

  const [openedMenus, setOpenedMenus] = useState<string[]>([
    documentation ? documentation : "",
  ]);

  const menu = documentations.map((item) => {
    const isActive = item.slug === documentation;
    const isOpened = openedMenus.includes(item.slug);
    return {
      ...item,
      isActive,
      isOpened,
    };
  });

  const onToggleDropdown = useCallback((slug: string) => {
    setOpenedMenus((prev) =>
      prev.includes(slug) ? prev.filter((s) => s !== slug) : [...prev, slug],
    );
  }, []);

  useEffect(() => {
    if (documentation) {
      setTimeout(() => {
        setOpenedMenus([documentation]);
      }, 900);
    }
  }, [documentation]);

  const styles = sideMenuVariant({ isMobileMenu });
  const WrapperEl: React.ElementType = isMobileMenu ? m.div : m.aside;

  return {
    className,
    styles,
    name,
    menu,
    onToggleDropdown,
    activeSection,
    onHandleOpenSideMenu,
    WrapperEl,
    onHandleMenu,
  };
};
